// @flow
import { combineActions, handleActions } from 'redux-actions';
import { upsertResource, upsertResources, upsertResourceSetupUndo, completeWithError, resetResources } from 'data/qcsSyncResourceReducerHelpers';

import * as actions from './actions';
import { mkCategoriesStore } from './types';

const reducer = handleActions({

  [actions.createCategory]:
    (state, { payload: category }) => upsertResource(state, category),
  [actions.createCategorySuccess]:
    (state, action) => upsertResourceSetupUndo(state, action, actions.deleteCategory),

  [actions.updateCategory]:
    (state, action) => upsertResourceSetupUndo(state, action, actions.updateCategory),
  [actions.updateCategorySuccess]:
    (state, { payload: category, asyncDispatch }) => {
      asyncDispatch(actions.getCategories());
      return upsertResource(state, category);
    },

  [actions.deleteCategory]:
    (state, action) => upsertResourceSetupUndo(state, action, actions.createCategory),
  [actions.deleteCategorySuccess]:
    (state, { payload: category }) => upsertResource(state, category),

  [actions.updateCategories]: (state) => state,
  [actions.updateCategoriesSuccess]:
    (state, { payload: data }) => upsertResources(state, data),

  [combineActions(
    actions.createCategoryFailure,
    actions.updateCategoryFailure,
    actions.updateCategoriesFailure,
    actions.deleteCategoryFailure,
  )]: (state, {payload: error, asyncDispatch}) => {
    asyncDispatch(actions.getCategories());
    return resetResources(state, error);
  },

  [actions.getCategories]:
    (state) => state.set('isLoading', true),
  [actions.getCategoriesSuccess]:
    (state, { payload: data }) => upsertResources(state, data),
  [actions.getCategoriesFailure]:
    (state, { payload: error }) => completeWithError(state, error),

}, mkCategoriesStore());

export const REDUCER_KEY = 'categoryStore';
export default reducer;
